import React, { useContext } from "react";
import { Footer } from "./footer";
import { DetailContent } from "./detail-content";
import { useService } from "../../../../../hooks/shared";
import { ScheduledProductHeader } from "../components/headers";
import { BaseServiceDetailModal } from "../../../../shared/modals";
import { ServicesLayerContext } from "../../../../../contexts/shared";
import { Skeleton } from "antd";

export function EntrepreneurScheduledProductDetailModal({
  // Could be injected by the modal provider
  selectedItem, // selected scheduled service
  ...props
}) {
  const { ScheduledExpertServiceService } = useContext(ServicesLayerContext);

  const {
    loading,
    data: scheduledExpertService
  } = useService(
    ScheduledExpertServiceService.getById,
    { id: selectedItem?.id },
    { shouldFetch: !!selectedItem?.id && props.visible }
  );

  const cancelScheduledServiceRequest = () => {
    alert("Se cancela");
  };

  return (
    <BaseServiceDetailModal
      header={<ScheduledProductHeader
        scheduledExpertService={scheduledExpertService} />}
      footer={<Footer
        onCancelScheduledService={cancelScheduledServiceRequest} />}
      {...props}>
      {loading
        ? <Skeleton paragraph={{ rows: 3 }} active />
        : <DetailContent scheduledExpertService={scheduledExpertService} />}
    </BaseServiceDetailModal>
  );
}